"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorType = exports.ActionTypes = exports.BucketCategories = void 0;
var BucketCategories;
(function (BucketCategories) {
    BucketCategories["GLOBAL"] = "GLOBAL";
    BucketCategories["URL"] = "URL";
    BucketCategories["ET"] = "ET";
})(BucketCategories = exports.BucketCategories || (exports.BucketCategories = {}));
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["ASSIGN"] = "assign";
    ActionTypes["ALLOCATE"] = "allocate";
    ActionTypes["BOOST"] = "boost";
    ActionTypes["ENABLE"] = "enable";
})(ActionTypes = exports.ActionTypes || (exports.ActionTypes = {}));
var MonitorType;
(function (MonitorType) {
    MonitorType["QUOTAS"] = "quotas";
    MonitorType["BOOSTS"] = "boosts";
})(MonitorType = exports.MonitorType || (exports.MonitorType = {}));
//# sourceMappingURL=session-replay-quotas.request.js.map